
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import HongBao from '@/components/HongBao.vue'

import Moment from 'moment'

import COVERAPP from '@/utils/COVERAPP'

@Options ({
    data () {
        return {
            showHb: false
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'dialogData', 'activityData'])
    },
    components: {
        HongBao
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_USERINFO', 'SET_HBDATA']),
        btnClick (btn: any) {
            if (btn.className === 'wxAuthorize-btn') {
                this.$common.track(this.aid, 'click', '绑定微信')
                this.wxAuthorize()
            } else if (btn.className === 'download-btn') {
                this.downloadApp(btn.data)
            } else if (btn.className === 'getHb-btn') {
                this.$common.track(this.aid, 'click', '新人惊喜礼')
                this.SET_HBDATA(true)
                this.SET_DIALOGDATA(null)
            } else {
                this.SET_DIALOGDATA(null)
            }
        },
        wxAuthorize() {
            let _this = this
            COVERAPP.Method.wxAuthorize({
                callback(res: any) {
                    let data = typeof res == 'string'.toLowerCase() ? res : JSON.stringify(res)
                    if (JSON.parse(data).status == 1) {
                        _this.SET_DIALOGDATA(null)
                        const openid = JSON.parse(data).openid
                        let verifyOpenid = `${_this.userInfo.user_id.toString(36)}_${openid}_${(+Moment().format("YYYYMMDD")).toString(36)}`
                        let userInfo = JSON.parse(JSON.stringify(_this.userInfo))
                        userInfo.openid = openid
                        _this.SET_USERINFO(userInfo)
                        _this.$nextTick(() => {
                            _this.bindWeixin(verifyOpenid)
                        })
                    }
                }
            })
        },
        bindWeixin (openid: string) {
            this.$request('/user/weixin/bind', {
                openid: openid,
                userinfo: this.userInfo
            }, 'put').then((data: any) => {
                this.SET_DIALOGDATA(null)
                this.$common.toast('绑定微信成功')
            }).catch((res: any) => {
                if (res.errno == 1251) {
                    this.SET_DIALOGDATA({
                        text: '您的微信号已授权，不能重复授权哦！',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                } else {
                    this.$common.toast('绑定微信失败')
                }
            })
        },
        downloadApp (data: any) {
            this.$common.downloadApp(this.aid, data.news_id, data.flag)
        }
    }
})
export default class Dialog extends Vue {}
